import React from "react";
import { Bullseye } from "@patternfly/react-core";
import { Spinner } from '@patternfly/react-core';

export default () => (
  <Bullseye>
    <Spinner size="xl" />
  </Bullseye>
);
